import React from 'react';
import { CheckIcon } from 'lucide-react';
import { salesPageData } from '../data/salesPageData';
import { CTAButton } from './ui/CTAButton';
export function VaultsSection() {
  return <section id="bonos" className="relative overflow-hidden border-t border-[#D89A3D]/20 bg-[#181512]" aria-labelledby="bonos-title" data-id="element-417" data-mp="2w79i0vpecudp">
      <div className="absolute right-[-15%] top-1/3 h-[480px] w-[480px] rounded-full bg-[#FF7A00]/10 blur-[150px]" aria-hidden="true" data-id="element-418" data-mp="2r9he13bh9ht5" />

      <div className="relative mx-auto max-w-content px-4 py-16 md:px-8 md:py-24" data-id="element-419" data-mp="3nwky001o73zy">
        <div className="mx-auto max-w-3xl text-center" data-id="element-420" data-mp="3jxvdlni7sm6t">
          <p className="font-display text-[10px] font-extrabold uppercase tracking-[0.24em] text-[#FF7A00]" data-id="element-421" data-mp="3exhcyqiy0eit">
            Incluidos hoy sin costo adicional
          </p>
          <h2 id="bonos-title" className="title-glow reveal mt-4 font-display text-3xl font-black uppercase leading-[1.05] tracking-tight text-[#F8F3EA] sm:text-5xl" data-id="element-422" data-mp="3a1aax8to3n65">
            Los 8 <span className="accent-glow text-[#FF7A00]" data-id="element-423" data-mp="1yiftemp0mu28">Bonos Especiales</span>
          </h2>
          <div className="gold-rule mx-auto mt-6 w-48" aria-hidden="true" data-id="element-424" data-mp="31s4hed5l4nfo" />
          <p className="mt-6 text-[15px] leading-relaxed text-[#EFEDE8]/70 sm:text-base" data-id="element-425" data-mp="35s6j2mbblguy">
            <span className="font-semibold text-[#F8F3EA]" data-id="element-426" data-mp="2ru83xep6dgee">
              Pero la Bóveda no termina en los 500+ proyectos.
            </span>{' '}
            También desbloqueás 8 bonos complementarios creados para resolver problemas
            específicos del carpintero.
          </p>
        </div>

        <ul className="mt-12 grid gap-5 md:grid-cols-2" data-id="element-427" data-mp="2mvdommqf29z1">
          {salesPageData.bonuses.map(bonus => <li key={bonus.number} className="premium-card reveal flex flex-col overflow-hidden rounded-2xl border border-[#D89A3D]/20 bg-[#111111] transition-all duration-300 hover:-translate-y-1 hover:border-[#FF7A00]/50 hover:shadow-[inset_0_1px_0_rgba(248,243,234,0.08),0_0_0_1px_rgba(216,154,61,0.28),0_0_46px_-14px_rgba(255,122,0,0.6),0_26px_60px_-32px_rgba(0,0,0,0.95)]" data-id="element-428" data-mp="293qg9oj79azw">
              <div className="flex flex-col gap-5 p-6 sm:flex-row" data-id="element-429" data-mp="1kyzapvg5clci">
                <div className="mx-auto w-32 shrink-0 sm:mx-0 sm:w-36" data-id="element-430" data-mp="1l1c0uvw2620n">
                  <img src={bonus.image} alt={`Mockup del Bono ${bonus.number}: ${bonus.name}`} className="w-full rounded-lg [filter:drop-shadow(0_0_14px_rgba(255,122,0,0.28))_drop-shadow(0_18px_30px_rgba(0,0,0,0.7))]" loading="lazy" width={1024} height={1024} data-id="element-431" data-mp="1g6y0ef2jh4p4" />
                </div>

                <div className="flex-1" data-id="element-432" data-mp="23x24enjn36gn">
                  <p className="inline-block rounded-md border border-[#FF7A00]/40 bg-[#FF7A00]/10 px-2.5 py-1 font-numeric text-[11px] font-bold uppercase tracking-[0.18em] text-[#FF7A00]" data-id="element-433" data-mp="23w0oa4nrnts2">
                    Bono #{bonus.number}
                  </p>
                  <h3 className="mt-2.5 font-display text-lg font-extrabold uppercase leading-tight tracking-tight text-[#F8F3EA]" data-id="element-434" data-mp="1ozsxumlrlw4c">
                    {bonus.name}
                  </h3>
                  <p className="mt-2.5 text-sm leading-relaxed text-[#EFEDE8]/60" data-id="element-435" data-mp="dle9qmn6u9b8">
                    {bonus.description}
                  </p>

                  <ul className="mt-4 space-y-1.5" data-id="element-436" data-mp="2p6y019gpz2kw">
                    {bonus.items.map(item => <li key={item} className="flex items-start gap-2 text-sm text-[#EFEDE8]/85" data-id="element-437" data-mp="2u8voci3z8nkp">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#FF7A00]" aria-hidden="true" data-id="element-438" data-mp="2z5m5z9vfjr88" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-4 border-l-2 border-[#D89A3D] pl-3 text-sm italic leading-relaxed text-[#D89A3D]" data-id="element-439" data-mp="38vyqx375pmew">
                    {bonus.benefit}
                  </p>
                </div>
              </div>

              <div className="mt-auto flex flex-wrap items-center justify-between gap-2 border-t border-[#D89A3D]/15 bg-[#181512] px-6 py-4" data-id="element-440" data-mp="3hy7wrfrhcrly">
                <p className="text-[11px] font-semibold uppercase tracking-wide text-[#EFEDE8]/45" data-id="element-441" data-mp="1njx8b8esrzgp">
                  Valor referencial:{' '}
                  <span className="font-numeric text-sm text-[#EFEDE8]/60 line-through" data-id="element-442" data-mp="1sjjn3ma9xnrm">
                    {bonus.value} {salesPageData.currency}
                  </span>
                </p>
                <p className="rounded-md border border-[#FF7A00]/40 bg-[#FF7A00]/12 px-3 py-1.5 font-display text-[11px] font-extrabold uppercase tracking-wider text-[#FF7A00]" data-id="element-443" data-mp="3dzpsleh24o9x">
                  Hoy: incluido gratis
                </p>
              </div>
            </li>)}
        </ul>

        <div className="premium-glow reveal mx-auto mt-12 max-w-2xl rounded-2xl border border-[#D89A3D]/40 bg-[#111111] p-7 text-center sm:p-10" data-id="element-444" data-mp="308kz6u4a8s81">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-[#EFEDE8]/55" data-id="element-445" data-mp="2v86of4bar46b">
            Valor referencial total de los 8 Bonos
          </p>
          <p className="mt-2 font-numeric text-4xl font-bold text-[#EFEDE8]/55 line-through sm:text-5xl" data-id="element-446" data-mp="349wpz2yw7jht">
            {salesPageData.bonusesTotalValue} {salesPageData.currency}
          </p>
          <p className="accent-glow mt-4 font-display text-sm font-extrabold uppercase leading-snug tracking-tight text-[#FF7A00] sm:text-base" data-id="element-447" data-mp="2ckl7nrz5cxse">
            Hoy: incluidos sin costo adicional con La Bóveda del Carpintero
          </p>
          <div className="mt-7 flex flex-col items-center" data-id="element-448" data-mp="277wa6luo6g3n">
            <CTAButton href="#oferta" size="large" data-id="element-449" data-mp="1signbgy9eut8">
              🔓 Quiero desbloquearlos todos
            </CTAButton>
          </div>
        </div>
      </div>
    </section>;
}